import {PinIcon, PinSlashIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

import {LABELS} from '../../constants'
import type {SavedView} from '../../types'

export interface PinControls {
  togglePin: (view: SavedView) => void
  pinnedCountForView: (view: SavedView) => number | undefined
  pinLimitForView: (view: SavedView) => number
  pinLimitLoading?: boolean
}

export function PinViewMenuItem({view, pinControls}: {view: SavedView; pinControls?: PinControls}) {
  if (!pinControls) return null

  const {togglePin, pinnedCountForView, pinLimitForView, pinLimitLoading} = pinControls
  const pinnedCount = pinnedCountForView(view)
  const pinLimit = pinLimitForView(view)
  const limitReached = !view.pinned && pinnedCount !== undefined && pinnedCount >= pinLimit
  const awaitingCount = !view.pinned && pinnedCount === undefined && pinLimitLoading

  return (
    <ActionList.Item
      loading={awaitingCount}
      inactiveText={limitReached ? LABELS.views.pinLimitReached(pinLimit) : undefined}
      onSelect={() => togglePin(view)}
    >
      <ActionList.LeadingVisual>{view.pinned ? <PinSlashIcon /> : <PinIcon />}</ActionList.LeadingVisual>
      <span>{view.pinned ? LABELS.views.unpin : LABELS.views.pin}</span>
    </ActionList.Item>
  )
}
